import { Box, Button, Divider, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useQuery } from "@tanstack/react-query";
import { decode } from "html-entities";
import { getRequest } from "@/utils/request";
import { magicConstants } from "@/utils/magic-constants";

type PrivacyModalProps = {
  open: boolean;
  onClose: () => void;
  lang: string;
};

const PrivacyModal = ({ open, onClose, lang }: PrivacyModalProps) => {
  const { data, isLoading } = useQuery({
    queryKey: ["information"],
    queryFn: () =>
      getRequest({
        path: { name: "information", id: String(magicConstants.privacyPolicyInformationId) },
        lang,
      }),
  });
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-offerz-privacy-policy"
      aria-describedby="modal-offerz-privacy-policy-description"
      closeAfterTransition
    >
      <Box
        sx={{
          color: "#666",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) !important",
          bgcolor: "background.paper",
          boxShadow: 24,
          px: "20px",
          borderRadius: 2,
          maxWidth: { xs: "90%", md: "80%" },
          width: "100%",
          outline: "none !important",
          maxHeight: "90%",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
            py: "15px",
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: "17px" }}>
            {data?.data?.meta_title ?? (isLoading ? "Loading..." : "Error")}
          </Typography>
          <Button
            onClick={onClose}
            sx={{
              height: "auto",
              minWidth: "unset",
              color: "#000",
              opacity: 0.5,
              p: 0,
              "&:hover": { opacity: 1 },
            }}
          >
            <CloseIcon />
          </Button>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <div
          className="pb-4 text-sm [&_ul]:list-disc [&_ul]:pl-5"
          dangerouslySetInnerHTML={{
            __html: decode(data?.data?.description || ""),
          }}
        />
      </Box>
    </Modal>
  );
};
export default PrivacyModal;
